module.exports = __webpack_public_path__ + "static/media/hpm-image-3.0e672f19.jpeg";